module.exports = __webpack_public_path__ + "static/test games-2cdb73b8970ef949e4c9ce1a0c404efb.png";